import { render } from "./TextPlugin.vue?vue&type=template&id=e5f4f2e8&scoped=true"
import script from "./TextPlugin.vue?vue&type=script&lang=js"
export * from "./TextPlugin.vue?vue&type=script&lang=js"

import "./TextPlugin.vue?vue&type=style&index=0&id=e5f4f2e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5f4f2e8"]])

export default __exports__